<template>
    <v-card>
        <v-col>
            <v-row class="ma-0 pa-0" v-if="!mobile">
                <v-btn icon @click="$emit('refresh')" class="mr-2 mt-4">
                    <v-icon>refresh</v-icon>
                </v-btn>
                <v-autocomplete class="mr-4" hide-details label="Operatore" v-model="localFiltri.operatore" clearable
                    no-data-text="Nessun dato disponibile" :items="elencoOperatori" style="max-width: 405px;"
                    @input="aggiorna" multiple :single-line="true" no-filter />
                <v-autocomplete class="mr-4" hide-details label="Cliente" v-model="localFiltri.cliente" clearable
                    no-data-text="Nessun dato disponibile" :items="elencoClienti" item-text="ragSoc"
                    item-value="codAnagrafica" @input="aggiorna" />

                <v-text-field v-model="localFiltri.dataDa" label="Data inizio" hide-details
                    style="max-width: 150px !important;" type="date" event-color="primary" />

                <v-text-field v-model="localFiltri.dataA" label="Data fine" hide-details
                    style="max-width: 150px !important;" type="date" event-color="primary" />

            </v-row>
            <v-row class="ma-0 pa-0" v-if="!mobile">
                <v-select :items="destinazioni" v-model="localFiltri.destinazione" hide-details
                    style="max-width: 155px;" label="Destinazione" class="ml-2 mr-4" @input="aggiorna" />
                <v-select :items="tipiOre" v-model="localFiltri.tipoOre" hide-details style="max-width: 150px;"
                    label="Tipo ore" @input="aggiorna" />
                <v-switch inset dense v-model="localSoloDaFatturare" @click="aggiorna"
                    label="Mostra solo importi da fatturare" hide-details class="mt-4 ml-2" />
                <v-switch inset dense v-model="localRaggruppaClienti" @click="aggiorna" label="Raggruppa clienti"
                    hide-details class="mt-4 ml-2" />
                <v-switch v-if="localRaggruppaClienti" inset dense v-model="localSeparaOperatori" @click="aggiorna"
                    label="Separa operatori" hide-details class="mt-4 ml-2" />
                <v-spacer />
                <v-btn @click="aggiorna" class="mt-3" color="primary">carica dati</v-btn>
            </v-row>

            <!-- MOBILE -->
            <div v-if="mobile">
                <v-row class="ma-0 pa-0">
                    <v-btn icon @click="$emit('refresh')">
                        <v-icon>refresh</v-icon>
                    </v-btn>
                    <v-autocomplete dense class="ml-1 mr-2" hide-details label="Operatore"
                        v-model="localFiltri.operatore" clearable no-data-text="Nessun dato disponibile"
                        :items="elencoOperatori" style="max-width: 120px;" multiple />
                    <v-col cols="6" class="ma-0 pa-0 pr-2">
                        <v-autocomplete dense hide-details label="Cliente" v-model="localFiltri.cliente" clearable
                            no-data-text="Nessun dato disponibile" :items="elencoClienti" item-text="ragSoc"
                            item-value="codAnagrafica" />
                    </v-col>
                </v-row>
                <v-row class="ma-0 pa-0">
                    <v-col cols="6" class="ma-0 pa-0">
                        <v-text-field v-model="localFiltri.dataDa" label="Data inizio" hide-details
                            style="max-width: 150px !important;" type="date" event-color="primary" />
                    </v-col>
                    <v-col cols="6" class="ma-0 pa-0">
                        <v-text-field v-model="localFiltri.dataA" label="Data fine" hide-details
                            style="max-width: 150px !important;" type="date" event-color="primary" />
                    </v-col>
                </v-row>
                <v-row class="ma-0 pa-0">
                    <v-col cols="4" class="ma-0 pa-0">
                        <v-select :items="destinazioni" v-model="localFiltri.destinazione" hide-details
                            style="max-width: 155px;" label="Destinazione" class="ml-2" />
                    </v-col>
                    <v-col cols="4" class="ma-0 pa-0">
                        <v-select class="ml-1" :items="tipiOre" v-model="localFiltri.tipoOre" hide-details
                            style="max-width: 150px;" label="Tipo ore" />
                    </v-col>
                    <v-col cols="4" class="ma-0 pa-0">
                        <v-switch dense v-model="localSoloDaFatturare" hide-details class="mt-3">
                            <template v-slot:label>
                                <span style="font-size: 0.8em;">Solo da fatturare</span>
                            </template>
                        </v-switch>
                    </v-col>
                    <v-row class="mb-0 mr-0 ml-0">
                        <v-col cols="4" class="ma-0 pa-0">
                            <v-switch dense v-model="localRaggruppaClienti" hide-details class="mt-3">
                                <template v-slot:label>
                                    <span style="font-size: 0.8em;">Raggruppa clienti</span>
                                </template>
                            </v-switch>
                        </v-col>
                        <v-col cols="4" class="pt-0 pb-0 pl-0 pr-0">
                            <v-switch v-if="localRaggruppaClienti" dense v-model="localSeparaOperatori" hide-details
                                class="mt-3 ml-2">
                                <template v-slot:label>
                                    <span style="font-size: 0.8em;">Separa operatori</span>
                                </template>
                            </v-switch>
                        </v-col>
                        <v-col cols="4" class="pb-0 pl-0 pr-0">
                            <v-btn small @click="aggiorna(); $emit('close');" color="primary"
                                style="width: 100%; height: 100%;">
                                carica dati
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-row>
                <v-row>
                    <v-spacer />
                    <v-btn text color="primary" @click="$emit('close')" v-if="mobile">
                        Chiudi
                    </v-btn>
                </v-row>
            </div>
        </v-col>
    </v-card>
</template>

<script>
export default {
    name: "FiltriRiepilogoOre",
    props: {
        filtri: { type: Object, required: true },
        elencoOperatori: { type: Array, required: true },
        elencoClienti: { type: Array, required: true },
        destinazioni: { type: Array, required: true },
        tipiOre: { type: Array, required: true },
        soloDaFatturare: { type: Boolean, default: false },
        raggruppaClienti: { type: Boolean, default: false },
        separaOperatori: { type: Boolean, default: false },
        mobile: { type: Boolean, default: false }
    },
    data() {
        return {
            calendarDataDa: false,
            calendarDataA: false,
            localFiltri: JSON.parse(JSON.stringify(this.filtri)),
            localSoloDaFatturare: this.soloDaFatturare,
            localRaggruppaClienti: this.raggruppaClienti,
            localSeparaOperatori: this.separaOperatori
        };
    },
    methods: {
        aggiorna() {
            // Aggiorna i filtri nel parent
            this.$emit("update:filtri", this.localFiltri);
            this.$emit("update:soloDaFatturare", this.localSoloDaFatturare);
            this.$emit("update:raggruppaClienti", this.localRaggruppaClienti);
            this.$emit("update:separaOperatori", this.localSeparaOperatori);
            this.$emit("aggiorna"/* , this.localFiltri */);
        },
    },


    watch: {
        filtri: {
            handler(val) {
                this.localFiltri = JSON.parse(JSON.stringify(val));
                console.log(this.localFiltri);
            },
            deep: true
        },
        soloDaFatturare(val) {
            this.localSoloDaFatturare = val;
        },
        raggruppaClienti(val) {
            this.localRaggruppaClienti = val;
        },
        separaOperatori(val) {
            this.localSeparaOperatori = val;
        },

        "localFiltri.dataDa": function (newVal, oldVal) {
            if (
                newVal != null &&
                newVal != "" &&
                this.localFiltri.dataA != null &&
                this.localFiltri.dataA != "" &&
                newVal > this.localFiltri.dataA
            ) {
                this.localFiltri.dataDa = oldVal;
                this.$toast.alert("Data non valida");
            }
            this.localFiltri.dataDaIT = this.$i2kFunctions.formatISODate(
                this.localFiltri.dataDa
            );
        },

        "localFiltri.dataA": function (newVal, oldVal) {
            if (
                newVal != null &&
                newVal != "" &&
                this.localFiltri.dataDa != null &&
                this.localFiltri.dataDa != "" &&
                newVal < this.localFiltri.dataDa
            ) {
                this.localFiltri.dataA = oldVal;
                this.$toast.alert("Data non valida");
            }
            this.localFiltri.dataAIT = this.$i2kFunctions.formatISODate(this.localFiltri.dataA);
        },
    },
};
</script>